export enum AccountBeneficiariesLocators {
	createAccountBeneficiaryButton = 'createAccountBeneficiaryButton',
	editAccountBeneficiaryButton = 'editAccountBeneficiaryButton',
	deleteAccountBeneficiaryButton = 'deleteAccountBeneficiaryButton',
	deleteAccountBeneficiarySaveButton = 'deleteAccountBeneficiarySaveButton',
	deleteAccountBeneficiaryCancelButton = 'deleteAccountBeneficiaryCancelButton',
}
